import React, { useState } from 'react';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';

// Sync › project › Toolkit › Refresh Res Rates — ported from the desktop's Scripts › Refresh Res Rates. Makes OPERA
// re-price each reservation on the list: fixes its rates, moves it to a TEMP rate plan and back to its own, then reads
// it back to confirm (toolkit property.js refresh-rate). If moving it back fails, the row says the reservation was LEFT
// ON THE TEMP RATE — put that one right by hand.

const COLUMNS = [
    { key: 'confirmationNo', label: 'Confirmation' },
    { key: 'resvNameId', label: 'Reservation ID' },
    { key: 'lastName', label: 'Last name' },
    { key: 'firstName', label: 'First name' },
    { key: 'arrivalDate', label: 'Arrival' },
    { key: 'rateCode', label: 'Rate code' },
    { key: 'result', label: 'Result' },
];

function ToolkitRefreshRatesPage() {
    const [tempRateCode, setTempRateCode] = useState('TEMP');
    const request = (row) => ({ area: 'property', op: 'refresh-rate', args: { resvNameId: row.resvNameId, tempRateCode: tempRateCode.trim() } });
    return (
        <ToolkitBatchPage title="Refresh Res Rates"
            subtitle="Make Opera Cloud re-price reservations by moving each to a temporary rate plan and back."
            fileTitle="Reservation list" fileLabel="Choose the reservation list (.xlsx or CSV)" accept=".xlsx,.csv,.txt"
            kind="refresh-rates" columns={COLUMNS} searchKeys={['confirmationNo', 'resvNameId', 'lastName']} exportName="Refresh_Rates"
            request={request} server={{ screen: 'refresh-rates', title: 'Refresh Res Rates', keyOf: (row) => row.resvNameId }}
            canRun={!!tempRateCode.trim()}
            options={(
                <div className="tkb-row">
                    <label><span>Temporary rate plan</span><input type="text" value={tempRateCode} onChange={(e) => setTempRateCode(e.target.value.toUpperCase())} style={{ width: 140 }} /></label>
                </div>
            )} />
    );
}

export default ToolkitRefreshRatesPage;
